import _ from "lodash";
import Accessor from "./Accessor";

class ZSearch {

  /**
   * 
   * @param {*[]} arr 
   * @param {String} searchText 
   * @returns 
   */
  static Filter(arr, searchText){
    if(!arr || !searchText) return arr;
    searchText = searchText.toLowerCase();
    return _.filter(arr, o => o._search && o._search.indexOf(searchText) >= 0);
  }

  /**
   * 
   * @param {*[]} arr 
   * @param {String[]} fields 
   * @returns 
   */
  static BuildSearchString(arr, fields = []){
    for(const o of arr){
      let searchStr = "";
      for(const v of fields){
        let fieldValue = Accessor.Get(o, v);
        if(fieldValue !== undefined && fieldValue !== null){
          searchStr += " " + this.GetAllLangValues(fieldValue);
        }
      }
      o._search = searchStr.toLowerCase().trim();
    }
    return arr;
  }

  /**
   * 
   * @param {*} fieldValue 
   * @returns 
   */
  static GetAllLangValues = (fieldValue) => {
    let allValues = [];
    if(_.isString(fieldValue)){
      allValues = [fieldValue];
    }else if(_.isArray(fieldValue)){
      _.map(fieldValue, o => {
        if(_.isString(o)){
          allValues.push(o);
        }else{
          let kvps = Accessor.NestedToKeyValuePairs(o);
          _.map(kvps, v => allValues.push(v));
        }
      });
    }else{
      let kvps = Accessor.NestedToKeyValuePairs(fieldValue);
      allValues = _.map(kvps, o => o);
    } 
    return allValues.join(" ").toLowerCase();
  };

}

export default ZSearch;